import homeReducer from "./reducers";
export { default as Home } from "./HomeComponent";
export { default as homeOperations } from "./operations";
export default homeReducer;
